module.exports = __webpack_public_path__ + "img/n3.bdd8be08.svg";